export default "__VITE_ASSET__DbHCCpGR__"